export default function(server) {
  server.loadFixtures()

  server.createList('event', 10, 'withImages')

  server.createList('menu', 10)
  server.createList('installation', 10)
}
